export enum PrizingOptions {
  GiftCard = "GIFT_CARD",
  CreditCard = "CREDIT_CARD",
  Physical = "PHYSICAL_PRIZE",
}
